
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.747 6.999a.75.75 0 10-1.5 0h1.5zm12.005 0a.75.75 0 00-1.5 0h1.5zm-4.001 1a.75.75 0 00-1.5 0h1.5zm-1.5 7.003a.75.75 0 001.5 0h-1.5zM7.749 7.999a.75.75 0 00-1.5 0h1.5zm-1.5 7.003a.75.75 0 001.5 0h-1.5zM1.497 3.247a.75.75 0 100 1.5v-1.5zm15.006 1.5a.75.75 0 000-1.5v1.5zM4.287 3.76a.75.75 0 001.423.475L4.287 3.76zm1.256-1.395l.711.237-.711-.237zM7.44.996v.75-.75zm3.118 0v.75-.75zm1.9 1.369l.712-.237-.712.237zm-.17 1.869a.75.75 0 001.424-.473l-1.423.473zM2.248 6.999v10.004h1.5V6.999h-1.5zm0 10.004a2.75 2.75 0 002.751 2.75v-1.5c-.69 0-1.25-.56-1.25-1.25h-1.5zm2.751 2.75h8.004v-1.5H4.998v1.5zm8.004 0a2.75 2.75 0 002.75-2.75h-1.5c0 .69-.56 1.25-1.25 1.25v1.5zm2.75-2.75V6.999h-1.5v10.004h1.5zm-5.501-9.004v7.003h1.5V7.999h-1.5zm-4.002 0v7.003h1.5V7.999h-1.5zM1.497 4.747h15.006v-1.5H1.497v1.5zm4.213-.512l.544-1.633-1.423-.474-.544 1.632 1.423.475zm.544-1.633a1.25 1.25 0 011.187-.856v-1.5a2.75 2.75 0 00-2.61 1.882l1.423.474zm1.187-.856h3.118v-1.5H7.44v1.5zm3.119 0c.539 0 1.018.344 1.188.856l1.423-.474A2.75 2.75 0 0010.558.246l.002 1.5zm1.188.855l.542 1.633 1.423-.473-.542-1.633-1.423.473z","fill":"#323232"}})])
          )
        }
      }
    